<template>
  <component :is="props.size" :class="classes">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { Size } from "./types";

export interface HeadingProps {
  size?: Size;
}

const props = withDefaults(defineProps<HeadingProps>(), {
  size: "h1",
});

const sizes = {
  h1: "tw-text-5xl tw-font-medium",
  h2: "tw-text-4xl tw-font-medium",
  h3: "tw-text-3xl tw-font-medium",
  h4: "tw-text-2xl tw-font-semibold",
  h5: "tw-text-xl tw-font-semibold",
  h6: "tw-text-lg tw-font-semibold",
};

const classes = computed(() => [
  "tw-text-dorian-gray-500",
  "tw-mb-3",
  sizes[props.size],
]);
</script>
